// extracted by mini-css-extract-plugin
module.exports =  {"root":"gRHEK8pP8FTxfL0yLSIk","zoomButton":"kgd7po4HzlA6qRGrGrHw","shortcut":"TUxURhYIIo9RS5lPGEL8"};